import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { changes, fields } from 'src/components/utils/fields'
import { useMediaQuery } from '@mui/material'
import { BufferService, LoadingContext, M_Button, M_Fieldset, M_Header, M_MessageBoard, NavigateContext } from 'src/M_Components'
import { Block, Refresh } from '@mui/icons-material'


export const LocationRestrictionCrud = () => {
    const [id, setId] = useState(sessionStorage.getItem('selectedTab'))
    const { t } = useTranslation()
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const [data, setData] = useState({})
    const [open, setOpen] = useState(false)
    const [passedRow, setPassedRow] = useState({})
    const [operation, setOperation] = useState('')
    const [isFirstTime, setIsFirstTime] = useState(true)
    const [leavingPage, setLeavingPage] = useState(false)
    const [isEditMode, setIsEditMode] = useState(false)
    const [editingId, setEditingId] = useState(null)

    const locationRestrictionService = new BufferService('LocationRestriction', 'secondary')
    const movementTypeService = new BufferService('MovementType', 'secondary')
    const accountService = new BufferService('Account')
    const locationService = new BufferService('Location')
    const countryService = new BufferService('Country')

    const sessionKeys = ['operation', 'data', 'open', 'passedRow', 'leavingPage']

    const matches9 = useMediaQuery('(min-width:1190px)')
    const matches16 = useMediaQuery('(min-width:440px)')

    const restrictionTypeBounds = [
        { label: t('None'), value: 'None' },
        { label: t('From'), value: 'From' },
        { label: t('To'), value: 'To' },
        { label: t('Final'), value: 'Final' },
    ]

    const LocationRestrictionFields = [
        {
            display: t('Movement') + ' ' + t('Type'),
            required: true,
            code: 'movementTypeCode',
            type: 'foreignKey',
            entity: 'MovementType',
            api: 'secondary',
            filterField: 'Code',
            labelFields: ['Code'],
            fields: [
                { key: 'Id', value: 'movementTypeId' },
                { key: 'Code', value: 'movementTypeCode' },
                { key: 'Name', value: 'movementTypeName' },
            ],
        },
        {
            display: t('Movement') + ' ' + t('Type') + ' ' + t('Name'),
            code: 'movementTypeName',
            type: 'disabled',
        },
        {
            display: t('Line'),
            required: true,
            code: 'lineName',
            type: 'foreignKey',
            entity: 'Account',
            filterField: 'AccountCode',
            labelFields: ['AccountCode'],
            fields: [
                { key: 'Id', value: 'lineId' },
                { key: 'AccountCode', value: 'lineName' },
            ],
        },
        {
            display: t('Type'),
            required: true,
            code: 'type',
            type: 'select',
            options: 'restrictionTypeBounds',
            extraField: 'typeValue',
        },
        {
            display: t('Location') + ' ' + t('Code'),
            required: true,
            code: 'locationCode',
            type: 'foreignKey',
            entity: 'Location',
            filterField: 'LocationName',
            labelFields: ['LocationName'],
            displayField: 'locationCode',
            fields: [
                { key: 'Id', value: 'locationId' },
                { key: 'LocationCode', value: 'locationCode' },
                { key: 'LocationName', value: 'locationName' },
                { key: 'LocationComments', value: 'locationComments' },
                { key: 'CountryId', value: 'countryId' },
                { key: 'CountryCode', value: 'countryCode' },
                { key: 'CountryName', value: 'countryName' },
                { key: 'LocationComments', value: 'locationComments' },
            ],
        },
        {
            display: t('Location') + ' ' + t('Name'),
            code: 'locationName',
            type: 'disabled',
        },
        {
            display: t('Country') + ' ' + t('Code'),
            code: 'countryCode',
            type: 'disabled',
        },
        {
            display: t('Country') + ' ' + t('Name'),
            code: 'countryName',
            type: 'disabled',
        },
        {
            display: t('Location') + ' ' + t('Comments'),
            code: 'locationComments',
            type: 'disabled',
        },
    ]


    useEffect(() => {
        if (isFirstTime) {
            ctx.setIsLoad(true)
            getSessionStorageData(id)
            setIsFirstTime(false)
            sessionStorage.setItem(`tab${id}`, JSON.stringify(sessionKeys))

            const editingLocationRestriction = JSON.parse(sessionStorage.getItem('editingLocationRestriction'))
            const operationType = sessionStorage.getItem('operationType')

            if (editingLocationRestriction && (operationType === 'Edit' || operationType === 'Copy')) {
                editOrCopyLocationRestriction(editingLocationRestriction.Id, operationType === 'Copy')

                sessionStorage.removeItem('editingLocationRestriction')
                sessionStorage.removeItem('operationType')
            } else if (operationType === 'Create') {
                setOperation('Create')
                sessionStorage.removeItem('operationType')
            }
        }
    }, [])

    useEffect(() => {
        const newId = sessionStorage.getItem('selectedTab')
        if (newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
        }
    })

    useEffect(() => {
        sessionKeys.forEach((key) => {
            sessionStorageMachine(id, key, key)
        })
        // eslint-disable-next-line
    }, [id, operation, data, leavingPage])

    const sessionStorageMachine = (id, key, value) => {
        if (eval(value) instanceof Object && Object.keys(eval(value)).length === 0) return
        if (eval(value) instanceof String && eval(value) === '') return
        if (eval(value) instanceof Number && eval(value) === '') return

        // eslint-disable-next-line
        if (eval(value) instanceof Map) {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(Array.from(eval(value))))
        } else {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(eval(value)))
        }
    }

    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true)
        const tempO = JSON.parse(sessionStorage.getItem(`${sessionID}operation`))
        const tempD = JSON.parse(sessionStorage.getItem(`${sessionID}data`))
        const tempOS = JSON.parse(sessionStorage.getItem(`${sessionID}open`))
        const tempPR = JSON.parse(sessionStorage.getItem(`${sessionID}passedRow`))
        const tempLP = JSON.parse(sessionStorage.getItem(`${sessionID}leavingPage`))

        if ((tempO && tempO !== '') || (tempD && Object.keys(tempD).length !== 0) || tempOS || (tempPR && Object.keys(tempD).length !== 0)) {
            setOperation(new String(tempO))
            setData(new Object(tempD))
            setOpen(tempOS)
            setPassedRow(tempPR)
            setLeavingPage(tempLP || false)
            ctx.setIsLoad(false)
            return
        }
        get()
    }

    const get = () => {
        ctx.setIsLoad(false)
    }

    const refreshLocationRestriction = () => {
        ctx.setIsLoad(true)

        sessionKeys.forEach(key => {
            sessionStorage.removeItem(`${id}${key}`)
        })

        setData({})
        setPassedRow({})
        setOpen(false)
        setOperation('')
        setLeavingPage(false)
        setIsEditMode(false)
        setEditingId(null)

        get()

        ctx.setIsLoad(false)
        ctx.toastMessages('success', t('Form refreshed'), '')
    }

    const onSave = async () => {

        if (!data.movementTypeId || !data.lineId || !data.type || !data.locationId) {
            ctx.toastMessages('error', '', t('Missing required fields'))
            return
        }

        const locationRestrictionData = {
            MovementTypeId: parseInt(data.movementTypeId),
            LineId: data.lineId,
            LineName: data.lineName || '',
            Type: data.type,
            LocationId: data.locationId,
            LocationCode: data.locationCode || '',
            LocationName: data.locationName || '',
            LocationComments: data.locationComments || '',
            CountryId: data.countryId || null,   // ← was: data.countryId
            CountryCode: data.countryCode || '',
            CountryName: data.countryName || '',
        }

        ctx.setIsLoad(true)

        const savePromise = isEditMode && editingId
            ? locationRestrictionService.update(editingId, locationRestrictionData)
            : locationRestrictionService.post(locationRestrictionData)

        savePromise.then(response => {
            ctx.setIsLoad(false)

            if (response.name === 'AxiosError') {
                handleError(response)
                return
            }

            const successMessage = isEditMode
                ? t('Location') + ' ' + t('Restriction') + ' ' + t('updatedSucessfully')
                : t('Location') + ' ' + t('Restriction') + ' ' + t('savedSucessfully')

            ctx.toastMessages('success', '', successMessage)
            ctx2.closeTab(JSON.parse(id))

        }).catch(error => {
            ctx.setIsLoad(false)
            handleError(error)
        })
    }

    const editOrCopyLocationRestriction = (locationRestrictionId, isCopy = false) => {
        ctx.setIsLoad(true)

        locationRestrictionService.getId(locationRestrictionId).then(async (response) => {
            if (response.name === 'AxiosError') {
                ctx.setIsLoad(false)
                ctx.toastMessages('error', '', t('Failed to load') + ' ' + t('Location') + ' ' + t('Restriction'))
                return
            }

            const locationRestrictionData = {
                movementTypeId: response.MovementTypeId?.toString() || '',
                movementTypeCode: response.MovementTypeCode?.toString() || '',
                movementTypeName: response.MovementTypeName?.toString() || '',
                lineId: response.LineId?.toString() || '',
                lineName: response.LineName?.toString() || '',
                type: response.Type?.toString() || '',
                typeValue: response.Type?.toString() || '',
                locationId: response.LocationId?.toString() || '',
                locationCode: response.LocationCode?.toString() || '',
                locationName: response.LocationName?.toString() || '',
                locationComments: response.LocationComments?.toString() || '',
                countryId: response.CountryId?.toString() || null,
                countryCode: response.CountryCode?.toString() || '',
                countryName: response.CountryName?.toString() || '',
                _originalId: isCopy ? locationRestrictionId : null,
                _isCopy: isCopy,
            }

            // Collect all secondary fetches that are needed
            const secondaryFetches = []

            if (response.MovementTypeId && !response.MovementTypeCode) {
                secondaryFetches.push(
                    movementTypeService.getId(response.MovementTypeId).then(movType => {
                        if (movType.name !== 'AxiosError') {
                            locationRestrictionData.movementTypeCode = movType.Code
                            locationRestrictionData.movementTypeName = movType.Name
                        }
                    })
                )
            }

            if (response.LineId && !response.LineName) {
                secondaryFetches.push(
                    accountService.getId(response.LineId).then(account => {
                        if (account.name !== 'AxiosError') {
                            locationRestrictionData.lineName = account.AccountCode
                        }
                    })
                )
            }

            if (response.LocationId && !response.LocationCode) {
                secondaryFetches.push(
                    locationService.getId(response.LocationId).then(async (location) => {
                        if (location.name !== 'AxiosError') {
                            locationRestrictionData.locationCode = location.LocationCode
                            locationRestrictionData.locationName = location.LocationName
                            locationRestrictionData.locationComments = location.LocationComments
                            locationRestrictionData.countryId = location.CountryId

                            // Country depends on location, so nest it here
                            if (location.CountryId) {
                                const country = await countryService.getId(location.CountryId)
                                if (country.name !== 'AxiosError') {
                                    locationRestrictionData.countryCode = country.Code
                                    locationRestrictionData.countryName = country.Name
                                }
                            }
                        }
                    })
                )
            } else if (response.CountryId && !response.CountryCode) {
                secondaryFetches.push(
                    countryService.getId(response.CountryId).then(country => {
                        if (country.name !== 'AxiosError') {
                            locationRestrictionData.countryCode = country.Code
                            locationRestrictionData.countryName = country.Name
                        }
                    })
                )
            }

            // Wait for ALL secondary fetches to complete before updating state
            await Promise.all(secondaryFetches)

            // Now set everything at once — single render, loader hides after all data is ready
            if (isCopy) {
                setIsEditMode(false)
                setEditingId(null)
                setOperation('Create')
            } else {
                setIsEditMode(true)
                setEditingId(locationRestrictionId)
                setOperation('Edit')
            }

            setData(locationRestrictionData)
            ctx.setIsLoad(false)  // ← only hides after ALL data is populated

        }).catch(error => {
            ctx.setIsLoad(false)
            console.error('Error loading location restriction:', error)
            ctx.toastMessages('error', '', t('Failed to load') + ' ' + t('Location') + ' ' + t('Restriction'))
        })
    }

    const handleError = (error) => {
        let errorMessage = t('Failed to create') + ' ' + t('Location') + ' ' + t('Restriction')
        if (Array.isArray(data)) {
            errorMessage = data.map(e => `${e.field}: ${e.message}`).join('\n')
        } else if (data?.errors) {
            errorMessage = Object.entries(data.errors)
                .map(([field, messages]) => `${field}: ${messages.join(', ')}`)
                .join('; ')
        } else if (data?.message) {
            errorMessage = data.field ? `${data.field}: ${data.message}` : data.message
        } else if (data?.detail) {
            errorMessage = data.detail
        } else if (data?.title) {
            errorMessage = data.title
        } else if (error.message) {
            errorMessage = error.message
        }

        ctx.toastMessages('error', '', errorMessage)
    }


    return (
        <div>
            <M_Header
                element={
                    <>
                        <M_Button
                            tooltip={t("Back")}
                            label={t("Back")}
                            icon={<i className="pi pi-arrow-left iconTable" style={{ width: '20px', color: ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-black)' }}></i>}
                            onClick={() => { setLeavingPage(true) }}
                        />
                        <M_Button
                            tooltip={t("Refresh")}
                            icon={<Refresh />}
                            label={t("Refresh")}
                            onClick={() => refreshLocationRestriction()}
                        />
                        <M_Button
                            tooltip={t("Save")}
                            icon={<i className="pi pi-save"></i>}
                            label={t("Save")}
                            onClick={() => onSave()}
                        />
                    </>
                }
            />
            <div style={{ margin: '20px' }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'auto' }}>
                    <M_Fieldset
                        labelInside
                        label={
                            <div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}>
                                <Block style={{ marginRight: '10px', scale: '1.3' }} />
                                {t('Location') + ' ' + t('Restriction') + ' ' + t('Details')}
                            </div>
                        }
                        elements={
                            <div style={{ display: 'grid', gridTemplateColumns: !matches16 && 'auto' || !matches9 && 'auto auto' || 'auto auto auto', justifyContent: 'space-evenly' }}>
                                {LocationRestrictionFields.map((field, index) => {
                                    if (field.type === 'separator') {
                                        return <div key={`separator-${index}`} style={{ gridColumn: '1 / -1', height: '0' }} />
                                    }

                                    if (field.fullWidth) {
                                        return (
                                            <div key={index} style={{ gridColumn: '1 / -1', width: '100%', marginTop: '10px' }}>
                                                {fields(field, index, data, setData, false, null, '100%')}
                                            </div>
                                        )
                                    }
                                    return fields(field, index, data, setData, null, null, '100%', restrictionTypeBounds)
                                })}
                            </div>
                        }
                    />
                </div>
                <div style={{ margin: '25px' }}></div>
            </div>
            <M_MessageBoard
                warning
                open={leavingPage}
                title={t("leavingPageTitle")}
                body={t("leavingPageBody")}
                footer={
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-red)'} onClick={() => setLeavingPage(false)} label={t("ButtonCancel")} />
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-green)'} onClick={() => ctx2.closeTab(JSON.parse(id))} label={t("ButtonConfirm")} />
                    </span>
                }
            />
        </div>
    )
}